<template>
  <div class="page_taskSet">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
      <div class="top-right">
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>AI小杰</el-breadcrumb-item>
          <el-breadcrumb-item>任务缺省设置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" type="card" @tab-click="changeTab">
          <el-tab-pane label="杰小薪设置" name="0"></el-tab-pane>
          <el-tab-pane label="杰小职设置" name="1"></el-tab-pane>
          <el-tab-pane label="杰小金设置" name="2"></el-tab-pane>
          <el-tab-pane label="任务缺省设置" name="3"></el-tab-pane>
          <!-- <el-tab-pane label="增强学习" name="4"></el-tab-pane> -->
          <el-tab-pane label="入职参保规则" name="5"></el-tab-pane>
          <el-tab-pane label="入职签约规则" name="6"></el-tab-pane>
        </el-tabs>
        <el-tabs v-model="activeName2">
          <el-tab-pane label="任务流程" name="0"></el-tab-pane>
          <el-tab-pane label="执行时间" name="1"></el-tab-pane>
          <el-tab-pane label="收发邮件" name="2"></el-tab-pane>
        </el-tabs>

        <el-form :model="ruleForm" label-width="200px" v-loading="loading" v-if="isOver" size="mini">
          <div v-if="activeName2=='0'">
            <div class="formTitle formTitle2"><span>|</span> 结算单任务 </div>
            <el-form-item label="自动生成结算单:">
              <el-radio-group v-model="ruleForm.自动流程缺省设置.结算机器人.自动生成生成单">
                <el-radio label="是">是</el-radio>
                <el-radio label="否">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="自动回传客户:">
              <el-radio-group v-model="ruleForm.自动流程缺省设置.结算机器人.自动回传客户">
                <el-radio label="是">是</el-radio>
                <el-radio label="否">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="自动申请发薪:">
              <el-radio-group v-model="ruleForm.自动流程缺省设置.结算机器人.自动申请发薪">
                <el-radio label="是">是</el-radio>
                <el-radio label="否">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="自动申请开票:">
              <el-radio-group v-model="ruleForm.自动流程缺省设置.结算机器人.自动申请开票">
                <el-radio label="是">是</el-radio>
                <el-radio label="否">否</el-radio>
              </el-radio-group>
            </el-form-item>

            <div class="formTitle formTitle2"><span>|</span> 雇佣服务流程 </div>

            <div class="formTitle formTitle3 formTitle2 "><span>|</span> 员工自助操作 </div>

            <el-form-item label-width="100px">
              <div class="empSetItem flex aic">
                <el-checkbox v-model="empSetForm.employee_1" :true-label="1" :false-label="0">允许自助到面登记</el-checkbox>
                <div class="pushItem">
                  <el-checkbox v-model="empSetForm.interviewPushNotification" :true-label="1" :false-label="0" :disabled="!empSetForm.employee_1">推送面试须知</el-checkbox>
                </div>
              </div>
            </el-form-item>
            <el-form-item label-width="100px">
              <div class="empSetItem flex aic">
                <el-checkbox v-model="employee_2" :true-label="1" :false-label="0">允许自助入职登记</el-checkbox>
                <el-radio-group v-model="empSetForm.employee_2" :disabled="!employee_2">
                  <el-radio :label="1"> 待入职</el-radio>
                  <el-radio :label="2"> 直接入职</el-radio>
                </el-radio-group>
              </div>
              <div class="pushItem" style="margin-left: 156px;">
                <el-checkbox v-model="empSetForm.onboardingNotification" :true-label="1" :false-label="0" :disabled="!employee_2">推送入职培训须知</el-checkbox>
              </div>
            </el-form-item>

            <el-form-item label-width="100px">
              <div class="empSetItem flex aic">
                <el-checkbox v-model="employee_3" :true-label="1" :false-label="0">自助入职自动电子签约</el-checkbox>
                <el-radio-group v-model="empSetForm.employee_3" :disabled="!employee_3">
                  <el-radio :label="1"> 不发签约通知</el-radio>
                  <el-radio :label="2"> 自动发送签约通知</el-radio>
                </el-radio-group>
              </div>
            </el-form-item>

            <el-form-item label-width="100px">
              <div class="empSetItem flex aic">
                <el-checkbox v-model="employee_4" :true-label="1" :false-label="0">自助入职自动参保</el-checkbox>
                <el-radio-group v-model="empSetForm.employee_4" :disabled="!employee_4">
                  <el-radio :label="1"> 加保待确认</el-radio>
                  <el-radio :label="2"> 无需确认，直接申请参保</el-radio>
                </el-radio-group>
              </div>
            </el-form-item>

            <el-form-item label-width="100px">
              <div class="empSetItem flex aic">
                <el-checkbox v-model="employee_5" :true-label="1" :false-label="0">允许自助离职登记</el-checkbox>
                <el-radio-group v-model="empSetForm.employee_5" :disabled="!employee_5">
                  <el-radio :label="1"> 待离职</el-radio>
                  <el-radio :label="2"> 直接离职</el-radio>
                </el-radio-group>
              </div>
            </el-form-item>

            <el-form-item label-width="100px">
              <div class="empSetItem flex aic">
                <el-checkbox v-model="employee_6" :true-label="1" :false-label="0">自助离职自动电子签约</el-checkbox>
                <el-radio-group v-model="empSetForm.employee_6" :disabled="!employee_6">
                  <el-radio :label="1"> 不发签约通知</el-radio>
                  <el-radio :label="2"> 自动发送签约通知</el-radio>
                </el-radio-group>
              </div>
            </el-form-item>

            <el-form-item label-width="100px">
              <div class="empSetItem flex aic">
                <el-checkbox v-model="employee_7" :true-label="1" :false-label="0">自助离职自动减保</el-checkbox>
                <el-radio-group v-model="empSetForm.employee_7" :disabled="!employee_7">
                  <el-radio :label="1"> 减保待确认</el-radio>
                  <el-radio :label="2"> 无需确认，直接申请减保</el-radio>
                </el-radio-group>
              </div>
            </el-form-item>


            <div class="formTitle formTitle3 formTitle2 "><span>|</span> 客服操作 </div>

            <el-form-item label-width="100px">
              <div class="empSetItem flex aic">
                <el-checkbox v-model="customerService_1" :true-label="1" :false-label="0">入职登记自动电子签约</el-checkbox>
                <el-radio-group v-model="empSetForm.customerService_1" :disabled="!customerService_1">
                  <el-radio :label="1"> 不发签约通知</el-radio>
                  <el-radio :label="2"> 自动发送签约通知</el-radio>
                </el-radio-group>
              </div>
            </el-form-item>

            <el-form-item label-width="100px">
              <div class="empSetItem flex aic">
                <el-checkbox v-model="customerService_2" :true-label="1" :false-label="0">入职登记自动参保</el-checkbox>
                <el-radio-group v-model="empSetForm.customerService_2" :disabled="!customerService_2">
                  <el-radio :label="1"> 加保待确认</el-radio>
                  <el-radio :label="2"> 无需确认，直接申请参保</el-radio>
                </el-radio-group>
              </div>
            </el-form-item>

            <el-form-item label-width="100px">
              <div class="empSetItem flex aic">
                <el-checkbox v-model="customerService_3" :true-label="1" :false-label="0">离职登记自动电子签约</el-checkbox>
                <el-radio-group v-model="empSetForm.customerService_3" :disabled="!customerService_3">
                  <el-radio :label="1"> 不发签约通知</el-radio>
                  <el-radio :label="2"> 自动发送签约通知</el-radio>
                </el-radio-group>
              </div>
            </el-form-item>

            <el-form-item label-width="100px">
              <div class="empSetItem flex aic">
                <el-checkbox v-model="customerService_4" :true-label="1" :false-label="0">离职自动减保</el-checkbox>
                <el-radio-group v-model="empSetForm.customerService_4" :disabled="!customerService_4">
                  <el-radio :label="1"> 减保待确认</el-radio>
                  <el-radio :label="2"> 无需确认，直接申请减保</el-radio>
                </el-radio-group>
              </div>
            </el-form-item>


            <!-- <el-form-item label="自动参保待确认:">
              <el-radio-group v-model="ruleForm.自动流程缺省设置.入职机器人.自动参保待确认">
                <el-radio label="是">是</el-radio>
                <el-radio label="否">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="自动签约登记:">
              <el-radio-group v-model="ruleForm.自动流程缺省设置.入职机器人.自动签约登记">
                <el-radio label="是">是</el-radio>
                <el-radio label="否">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="自动签约发送短信:">
              <el-radio-group v-model="ruleForm.自动流程缺省设置.入职机器人.自动签约发送短信">
                <el-radio label="是">是</el-radio>
                <el-radio label="否">否</el-radio>
              </el-radio-group>
            </el-form-item> -->

            <div class="formTitle formTitle2"><span>|</span> 银行任务 </div>
            <el-form-item label="自动导入:">
              <el-radio-group v-model="ruleForm.自动流程缺省设置.银行机器人.自动导入">
                <el-radio label="是">是</el-radio>
                <el-radio label="否">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <div v-if="activeName2=='1'">
            <div class="formTitle formTitle2"><span>|</span> 结算机器人 </div>
            <el-form-item label="频次:">
              <div class="flex">
                每
                <el-input v-model="ruleForm.执行时间缺省设置.结算机器人.频次.间隔" style="width:40px;margin:0 5px ;" type="number"></el-input>
                <el-select v-model="ruleForm.执行时间缺省设置.结算机器人.频次.单位" placeholder="" style="width: 80px;margin:0 5px">
                  <el-option value="分"></el-option>
                  <el-option value="小时"></el-option>
                  <el-option value="天"></el-option>
                  <el-option value="周"></el-option>
                  <el-option value="月"></el-option>
                  <el-option value="季度"></el-option>
                  <el-option value="年"></el-option>
                </el-select>
                1次
              </div>
            </el-form-item>

            <el-form-item label="起止日期:">
              <div v-for="(item,index) in ruleForm.执行时间缺省设置.结算机器人.起止日期" :key="index" class="flex">
                <span>{{ item.开始日 }} ~ {{ item.结束日 }} </span>
                <span style="margin-left: 10px;">{{ item.时间 }}</span>
                <span class="blueName cp" style="margin-left: 20px;" @click="delTimeSet(1,index)">删除</span>
              </div>
              <div class="blueName cp" @click="addTimeSet(1)">+添加</div>
            </el-form-item>
          </div>

          <div v-if="activeName2=='2'">
            <div class="ftabBtn">
              <el-button type="success" size="small" @click="addEmailSet">+添加</el-button>
            </div>
            <el-table :data="ruleForm.收发邮件" border class="doc_table" v-loading="loading" style="width:100%">
              <el-table-column prop="orderNumber" label="邮件域名" min-width="180" :show-overflow-tooltip="true" align="center">
                <template slot-scope={row}>
                  <el-input v-model="row.邮件域名" size="small" style="width:160px;"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="orderNumber" label="支持IMAP/SMTP" min-width="140" :show-overflow-tooltip="true" align="center">
                <template slot-scope={row}>
                  <el-select v-model="row['支持IMAP_SMTP']" size="small" placeholder="" style="width:120px;">
                    <el-option label="是" :value="true"></el-option>
                    <el-option label="否" :value="false"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="orderNumber" label="接收服务器" min-width="180" :show-overflow-tooltip="true" align="center">
                <template slot-scope={row}>
                  <el-input v-model="row.接收服务器" size="small" style="width:160px;"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="orderNumber" label="接收端口号" min-width="120" :show-overflow-tooltip="true" align="center">
                <template slot-scope={row}>
                  <el-input v-model="row.接收端口号" size="small" style="width:100px;"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="orderNumber" label="发送服务器" min-width="120" :show-overflow-tooltip="true" align="center">
                <template slot-scope={row}>
                  <el-input v-model="row.发送服务器" size="small" style="width:100px;"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="orderNumber" label="发送端口号" min-width="120" :show-overflow-tooltip="true" align="center">
                <template slot-scope={row}>
                  <el-input v-model="row.发送端口号" size="small" style="width:100px;"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" fixed="right" align="center" width="100">
                <template slot-scope={$index}>
                  <div class="injuryTabBtn">
                    <el-button type="text" size="small" @click="delEmailSet($index)">删除</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form>

        <div class="btn_box">
          <el-button type="success" @click="submit" size="small">保 存</el-button>
          <el-button @click="backHandle" size="small">取 消</el-button>
        </div>
      </div>

    </div>

    <el-dialog title="添加起止日期" :visible.sync="addTimeVisible" width="740px" class="res_dialog enter_dialog">
      <el-form ref="addForm" :model="addForm" label-width="100px" size="small">
        <el-form-item label="起止日期:" prop="ownershipMonth">
          <div class="flex">
            <el-select v-model="addForm.timeType" placeholder="" style="width:80px;margin-left: 10px;">
              <el-option value="每周"></el-option>
              <el-option value="每月"></el-option>
              <el-option value="每季度"></el-option>
              <el-option value="每年"></el-option>
            </el-select>
            <el-select v-model="addForm.start" placeholder="" filterable style="width:80px;margin-left: 10px;">
              <el-option v-for="(item,index) in 30" :key="index" :value="item + '日'"></el-option>
            </el-select>
            <span style="margin-left: 10px;"> ~ </span>
            <el-select v-model="addForm.end" placeholder="" filterable style="width:80px;margin-left: 10px;">
              <el-option v-for="(item,index) in 30" :key="index" :value="item + '日'"></el-option>
              <el-option value="月末"></el-option>
            </el-select>
            <el-time-picker v-model="addForm.startTime" format="HH:mm" value-format="HH:mm" placeholder="" style="width:100px;margin-left: 10px;">
            </el-time-picker>
            <span style="margin-left: 10px;"> ~ </span>
            <el-time-picker v-model="addForm.endTime" format="HH:mm" value-format="HH:mm" placeholder="" style="width:100px;margin-left: 10px;">
            </el-time-picker>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addTimeVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmAddTimeSet" size="small">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="添加收发邮件" :visible.sync="addEmailSetVisible" width="550px" class="res_dialog enter_dialog">
      <el-form ref="emailForm" :model="emailForm" label-width="130px" size="small">
        <el-form-item label="邮件域名:">
          <el-input v-model="emailForm.邮件域名" size="small" style="width:300px;"></el-input>
        </el-form-item>
        <el-form-item label="支持IMAP/SMTP:">
          <el-select v-model="emailForm['支持IMAP_SMTP']" size="small" placeholder="" style="width:300px;">
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="接收服务器:">
          <el-input v-model="emailForm.接收服务器" size="small" style="width:300px;"></el-input>
        </el-form-item>
        <el-form-item label="接收端口号:">
          <el-input v-model="emailForm.接收端口号" size="small" style="width:300px;"></el-input>
        </el-form-item>
        <el-form-item label="发送服务器:">
          <el-input v-model="emailForm.发送服务器" size="small" style="width:300px;"></el-input>
        </el-form-item>
        <el-form-item label="发送端口号:">
          <el-input v-model="emailForm.发送端口号" size="small" style="width:300px;"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addEmailSetVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmAddEmailSet" size="small">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        activeName: '3',
        activeName2: '0',
        roletype: localStorage.loginRoletype,
        loading: false,
        isOver: false,
        projectList: [], //项目列表
        ruleForm: {
          name: ''
        },
        addForm: {
          timeType: '',
          start: '',
          end: '',
          startTime: '',
          endTime: ''
        },
        type: null,
        addTimeVisible: false,
        addEmailSetVisible: false,
        emailForm: {
          邮件域名: '',
          '支持IMAP_SMTP': '',
          接收服务器: '',
          接收端口号: '',
          发送服务器: '',
          发送端口号: '',
        },
        employee_2: 0,
        employee_3: 0,
        employee_4: 0,
        employee_5: 0,
        employee_6: 0,
        employee_7: 0,
        customerService_1: 0,
        customerService_2: 0,
        customerService_3: 0,
        customerService_4: 0,
        empSetForm: {
          employee_1: 0, //允许自助到面登记：1：是；0：否
          interviewPushNotification: 0, //推送面试须知：1：是；0：否
          employee_2: 0, //允许自助入职登记：0：否；1：待入职；2：直接入职
          onboardingNotification: 0, //推送入职培训须知：1：是；0：否
          employee_3: 0, //自助入职自动电子签约：0：否；1：不发签约通知；2：自动发送签约通知
          employee_4: 0, //自助入职自动参保：0：否；1：加保待确认；2：无需确认，直接申请参保
          employee_5: 0, //允许自助离职登记：0：否；1：待离职；2：直接离职
          employee_6: 0, //自助离职自动电子签约：0：否；1：不发签约通知；2：自动发送签约通知
          employee_7: 0, //自助离职自动减保：0：否；1：减保待确认；2：无需确认，直接申请减保
          customerService_1: 0, //入职登记自动电子签约0：否；1：不发签约通知；2：自动发送签约通知
          customerService_2: 0, //入职登记自动参保0：否；1：加保待确认；2：无需确认，直接申请参保
          customerService_3: 0, //离职登记自动电子签约0：否；1：不发签约通知；2：自动发送签约通知
          customerService_4: 0, //离职登记登记自动减保0：否；1：减保待确认；2：无需确认，直接申请减保
        },
      }
    },
    created() {
      // this.getProList();
      // this.getButtonPower();
      this.GetTaskDefaultConfiguration();
      this.GetEmploymentServicesDefault();
    },
    methods: {
      checkPermission,
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.projectList = res.msg;
          } else {
            this.projectList = [];
          }
        });
      },
      GetTaskDefaultConfiguration() {
        this.loading = true;
        this.isOver = false;
        xz.GetTaskDefaultConfiguration().then(res => {
          if (res.status == 'ok') {
            this.ruleForm = res.data;
            this.loading = false;
            this.isOver = true;
          } else {
            this.loading = false;
          }
        })
      },
      //查询雇佣服务流程默认信息
      GetEmploymentServicesDefault() {
        const str = 'GetEmploymentServicesDefault';
        xz.TaskSetupGetFun(str)
          .then(res => {
            if (res.status === 'ok' && res.data) {
              this.empSetForm = res.data;

              // 定义需要处理的字段列表
              const employeeFields = [
                'employee_2', 'employee_3', 'employee_4',
                'employee_5', 'employee_6', 'employee_7'
              ];
              const customerServiceFields = [
                'customerService_1', 'customerService_2',
                'customerService_3', 'customerService_4'
              ];

              // 统一处理逻辑
              [...employeeFields, ...customerServiceFields].forEach(field => {
                if (res.data[field] != 0) {
                  this[field] = 1;
                }
              });
            } else {
              this.loading = false;
            }
          })
          .catch(err => {
            console.error('请求失败:', err);
            this.loading = false;
          });
      },
      changeTab() {
        if (this.activeName == '0') {
          this.$router.push({
            path: '/settlementTask'
          })
        } else if (this.activeName == '1') {
          this.$router.push({
            path: '/jobTask'
          })
        } else if (this.activeName == '2') {
          this.$router.push({
            path: '/bankSet'
          })
        } else if (this.activeName == '3') {
          this.getList();
        } else if (this.activeName == '4') {
          this.$router.push({
            path: '/dict'
          })
        } else if (this.activeName == '5' || this.activeName == '6') {
          this.$router.push({
            path: '/ruleSet',
            query: {
              activeName: this.activeName
            }
          })
        }
      },
      submit() {
        this.isbtnLoading = true;
        this.ruleForm.执行时间缺省设置.结算机器人.频次.显示文本 = `每${this.ruleForm.执行时间缺省设置.结算机器人.频次.间隔}${this.ruleForm.执行时间缺省设置.结算机器人.频次.单位}1次`
        let d = {
          BusiId: 10,
          id: 0,
          msg1: JSON.stringify(this.ruleForm)
        }
        xz.RPAFun(d, 'CreateOrEditDicData').then(res => {
          this.isbtnLoading = false;
          if (res.status == 'ok') {
            // this.$message.success('保存成功！');
            xz.TaskSetupFun(this.empSetForm, 'SetEmploymentServicesDefaultSave').then(r => {
              if (r.status === 'ok') {
                this.$message.success('保存成功！');
              } else {
                this.$message.error(r.msg);
                this.isbtnLoading = false;
              }
            })
          } else {
            this.$message.error(res.msg);
            this.isbtnLoading = false;
          }
        })
      },
      backHandle() {
        this.$router.go(-1)
      },
      addTimeSet(type) {
        this.type = type;
        this.addForm = {
          timeType: '',
          start: '',
          end: '',
          startTime: '',
          endTime: ''
        }
        this.addTimeVisible = true;
      },
      confirmAddTimeSet() {
        if (this.addForm.timeType && this.addForm.start && this.addForm.end && this.addForm.startTime && this.addForm.endTime) {
          let d = {
            开始日: this.addForm.timeType + this.addForm.start,
            结束日: this.addForm.timeType + this.addForm.end,
            时间: `${this.addForm.startTime} ~ ${this.addForm.endTime}`
          }
          if (this.type == 1) {
            this.ruleForm.执行时间缺省设置.结算机器人.起止日期.push(d)
            this.addTimeVisible = false;
          }
        } else {
          this.$message.warning('请完善起止日期')
        }
      },
      delTimeSet(type, index) {
        if (type == 1) {
          this.ruleForm.执行时间缺省设置.结算机器人.起止日期.splice(index, 1)
        }
      },
      delEmailSet(i) {
        this.ruleForm.收发邮件.splice(i, 1)
      },
      addEmailSet() {
        this.emailForm = {
          邮件域名: '',
          '支持IMAP_SMTP': '',
          接收服务器: '',
          接收端口号: '',
          发送服务器: '',
          发送端口号: '',
        };
        this.addEmailSetVisible = true;
      },
      confirmAddEmailSet() {
        this.ruleForm.收发邮件.push(this.emailForm);
        this.addEmailSetVisible = false;
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .formTitle {
    font-weight: 600;
    font-size: 14px;
  }

  .formTitle span {
    color: #F59A23;
    font-size: 18px;
  }

  .formTitle2 {
    margin-left: 50px;
    margin-bottom: 15px;
  }

  .formTitle3 {
    margin-left: 70px;
    font-size: 13px;
  }

  .formTitle3 span {
    color: #19BD92;
    font-size: 18px;
  }

  .btn_box {
    // width: 500px;
    display: flex;
    justify-content: center;
    margin-top: 30px;
    padding-bottom: 30px;
  }

  .ftabBtn {
    padding-bottom: 10px;
  }
</style>
<style>
  .page_taskSet .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_taskSet .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_taskSet .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_taskSet .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_taskSet .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_taskSet .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_taskSet .empSetItem .el-checkbox__label {
    margin-right: 20px;
    font-weight: 550;
  }

  .page_taskSet .pushItem .el-checkbox__label {
    font-weight: 400;
    font-size: 13px;
  }
</style>